// GENERATED FILE, PLEASE DO NOT EDIT
var Circle = 'Circle';
var Pill = 'Pill';
var Rectangle = 'Rectangle';
var ShapeTokensAll = {
  Circle: Circle,
  Pill: Pill,
  Rectangle: Rectangle
};

export { Circle, Pill, Rectangle, ShapeTokensAll, ShapeTokensAll as default };
